import React, { CSSProperties } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Button from './button/Button';
import { CommonValidation } from './commonValidation/commonValidation';
import { ButtonProps } from './CommonTypes';

export type ModalDialogProps = {
    showDialog: boolean;
    title?: string;
    children: React.ReactNode;
    primaryButton?: ButtonProps;
    secondaryButton?: ButtonProps;
    hideFooter?: boolean;
    minimumHeight?: string;
    additionalModalStyle?: CSSProperties;
    errorMessage?: string;
    onCloseClick: () => void;
};

const ModalDialog = ({
    showDialog,
    title,
    children,
    primaryButton,
    secondaryButton,
    hideFooter,
    minimumHeight,
    additionalModalStyle,
    errorMessage,
    onCloseClick
}: ModalDialogProps): JSX.Element => {
    return (
        <div>
            <Modal isOpen={showDialog}>
                {title && (
                    <ModalHeader toggle={onCloseClick}>{title}</ModalHeader>
                )}
                <ModalBody
                    style={{
                        ...additionalModalStyle,
                        minHeight: minimumHeight
                    }}>
                    {children}
                </ModalBody>
                {hideFooter !== true && (
                    <ModalFooter>
                        <ModalFooterButtons
                            primaryButton={primaryButton}
                            secondaryButton={secondaryButton}
                        />
                        <ModalErrorPanel errorMessage={errorMessage} />
                    </ModalFooter>
                )}
            </Modal>
        </div>
    );
};

type ModalFooterButtonsProps = {
    primaryButton?: ButtonProps;
    secondaryButton?: ButtonProps;
};

const ModalFooterButtons = ({
    primaryButton,
    secondaryButton
}: ModalFooterButtonsProps): JSX.Element => {
    return (
        <>
            <Button
                name={primaryButton.name}
                text={primaryButton.text}
                disabled={primaryButton.disabled}
                className={primaryButton.className || 'btn btn-primary'}
                waitValue={primaryButton.waitValue}
                waitText={primaryButton.waitText}
                onClick={primaryButton.onClick}></Button>
            <Button
                name={secondaryButton.name}
                text={secondaryButton.text}
                disabled={secondaryButton.disabled}
                className={secondaryButton.className || 'btn btn-secondary'}
                waitValue={secondaryButton.waitValue}
                waitText={secondaryButton.waitText}
                onClick={secondaryButton.onClick}></Button>
        </>
    );
};

type ModalErrorPanelProps = {
    errorMessage?: string;
};

const ModalErrorPanel = ({
    errorMessage
}: ModalErrorPanelProps): JSX.Element => {
    if (CommonValidation.isEmpty(errorMessage)) {
        return <></>;
    } else {
        return (
            <div className='row'>
                <div className='alert alert-danger' role='alert'>
                    {errorMessage}
                </div>
            </div>
        );
    }
};

export default ModalDialog;
